module.exports = __webpack_public_path__ + "media/images/ES-da4fbf324ceb64aca7e527846601544c.png";